import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { PropType } from "vue";

import { useFilesStore } from "@/stores/files.store";
import { useUIFilesStore } from "@/stores/ui-files.store";

import { ContentStructureSection } from "@/models/content-structure.model";

import { useFileManager } from "@/composables/files-manager";

import Popup from "@/components/Popup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RemoveAttachment',
  props: {
  section: {
    type: Object as PropType<ContentStructureSection>,
    required: true
  }
},
  setup(__props) {

const uiFilesStore = useUIFilesStore();
const filesStore = useFilesStore();
const { unlinkFileFromSection } = useFileManager();

const props = __props;

const removeAttachment = (): void => {
  if (uiFilesStore.fileToRemoveLink) {
    unlinkFileFromSection({
      productId: props.section.product_id,
      linkId: uiFilesStore.fileToRemoveLink.file_to_section_id
    }).then(() => {
      uiFilesStore.closeRemoveAttachmentModal();
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(Popup, {
    "data-testing-modal-card": 'remove-attachment-card',
    onClosePopup: _unref(uiFilesStore).closeRemoveAttachmentModal
  }, {
    header: _withCtx(() => [
      _createElementVNode("h3", null, [
        _cache[0] || (_cache[0] = _createTextVNode(" Remove attachment ")),
        _createElementVNode("i", null, _toDisplayString(_unref(uiFilesStore).fileToRemoveLink.name), 1)
      ])
    ]),
    body: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("p", null, "Removing this attachment will remove it from this piece of content", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("p", null, "The attachment will still be available in the Attachments library", -1)),
      _createElementVNode("p", null, [
        _cache[2] || (_cache[2] = _createTextVNode("To permanently delete this attachment, it must be deleted it from the ")),
        _createVNode(_component_router_link, {
          to: { name: 'files' },
          class: "btn-3"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Attachment library ")
          ])),
          _: 1
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        disabled: _unref(filesStore).areFilesUpdating,
        class: "btn-1 full-width margin-t-standard",
        "data-testing": "remove-attachment-btn",
        onClick: removeAttachment
      }, " Remove ", 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["onClosePopup"]))
}
}

})